import React from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import ProjectList from './ProjectList/ProjectList'
import RateTablesView from './RateTables/RateTablesView'
import LineItemsView from './LineItems/LineItemsView'
import ProjectDashboard from './ProjectDashboard/ProjectDashboard'
import BidOutputView from './Output/BidOutputView'
import VendorQuotesTab from './VendorQuotes/VendorQuotesTab'
import BidResponseWorkspace from './BidResponse/BidResponseWorkspace'
import ModuleWorkspace from './ModuleWorkspace/ModuleWorkspace'
import EstimateReviewView from './EstimateReview/EstimateReviewView'
import PostCloseView from './PostClose/PostCloseView'
import MaterialsRollupView from './Materials/MaterialsRollupView'
import ServiceBuilderView from './ServiceBuilder/ServiceBuilderView'
import InBidRatesView from './Rates/InBidRatesView'
import EstimatingCockpit from './Estimating/EstimatingCockpit'

const BidEstimation = (props) => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path} render={() => <ProjectList {...props} />} />
      <Route path={`${path}/rates`} render={() => <RateTablesView {...props} />} />
      <Route path={`${path}/:projectId/items`} render={() => <LineItemsView {...props} />} />
      <Route path={`${path}/:projectId/output`} render={() => <BidOutputView {...props} />} />
      <Route path={`${path}/:projectId/vendor-quotes`} render={(routeProps) => <VendorQuotesTab projectId={routeProps.match.params.projectId} {...props} />} />
      <Route path={`${path}/:projectId/bid-response/:packageId`} render={(routeProps) =>
        <BidResponseWorkspace
          projectId={routeProps.match.params.projectId}
          packageId={routeProps.match.params.packageId}
          {...props}
        />
      } />
      <Route path={`${path}/:projectId/estimate-review`} render={() => <EstimateReviewView {...props} />} />
      <Route path={`${path}/:projectId/post-close`} render={() => <PostCloseView {...props} />} />
      <Route path={`${path}/:projectId/materials`} render={() => <MaterialsRollupView {...props} />} />
      <Route path={`${path}/:projectId/modules/:moduleId`} render={(routeProps) => <ModuleWorkspace {...routeProps} {...props} />} />
      <Route path={`${path}/:projectId/service-builder`} render={() => <ServiceBuilderView {...props} />} />
      <Route path={`${path}/:projectId/rates`} render={() => <InBidRatesView {...props} />} />
      <Route path={`${path}/:projectId/estimating`} render={() => <EstimatingCockpit />} />
      <Route path={`${path}/:projectId`} render={() => <ProjectDashboard {...props} />} />
    </Switch>
  )
}

export default BidEstimation
